import { gql } from '@apollo/client';
import React from 'react';
import { ProductListingVisualStyleFilterFragment } from '../../../generated/types/ProductListingVisualStyleFilterFragment';
import { CATEGORY_TREE_FRAGMENT } from '../../../hooks/useCategoryTree';
import { PAGE_FILTER_NAME_SLUG_FACET_FRAGMENT } from '../../PageFilter';
import { VisualStyleFilters } from './VisualStyleFilters';

export const PRODUCT_LISTING_VISUAL_STYLE_FILTER_FRAGMENT = gql`
  fragment ProductListingVisualStyleFilterFragment on CollectionResult {
    visualStyleFilters: attributes {
      ...PageFilterNameSlugFacetFragment
    }
    ...CategoryTreeFragment
  }
  ${PAGE_FILTER_NAME_SLUG_FACET_FRAGMENT}
  ${CATEGORY_TREE_FRAGMENT}
`;

export interface Props {
  filters: ProductListingVisualStyleFilterFragment['visualStyleFilters'];
  categoryTree: ProductListingVisualStyleFilterFragment['categoryTree'];
}

export const ProductListingVisualStyleFilters: React.FC<Props> = ({ filters, categoryTree }) => {
  if (!filters) return null;

  if (filters.length === 0) return null;

  return <VisualStyleFilters filters={filters} categoryTree={categoryTree} />;
};
